import { Component, OnInit, Input } from '@angular/core';
import { InclExcl, inclusions, exclusions } from './terms-conditions';
import { discount } from 'app/markup/markup';
import { WebServiceService } from 'app/web-service.service';
import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  @Input() heading :string;
 
  inclusions: inclusions; 
  exclusions: exclusions;
  inclusionList = []; 
  termsList = [];
  exclusionList =[];
  overviewtext:any;
  parkId:any;
  termsId:any;
  @Input() headerParts:boolean;
  constructor(public loaderService: LoaderService,public service:WebServiceService) { }

  getGridData(){
    this.service.httpGet('get/term/'+this.parkId).subscribe((data:any)=>{
      this.overviewtext=data.data.contentJson.overview
      this.exclusionList=data.data.contentJson.excl
      this.inclusionList=data.data.contentJson.incl
      this.termsList=data.data.contentJson.terms
    })
  }
  onExclusionAdd(){
    this.exclusionList.push(new discount());
  }
  onAdd(index) {
    this.inclusionList.push(new discount())

  }
  onTermsAdd(){
    this.termsList.push(new discount())
  }
  onDelInclusion(index) {
    this.inclusionList.splice(index, 1);
  }
  onDelExclusion(index) {
    this.exclusionList.splice(index, 1);
  }
  onDelDel(index) {
    this.termsList.splice(index, 1);

  }
  ngOnChanges(){
    this.parkId=JSON.parse(sessionStorage.getItem('parkId'));
    this.termsId=JSON.parse(sessionStorage.getItem('termsId'));
    this.getGridData();
  }
  ngOnInit() {
    this.parkId=JSON.parse(sessionStorage.getItem('parkId'));
    this.termsId=JSON.parse(sessionStorage.getItem('termsId'));

  }
  onSubmit(){
    let termsDetails={
      "id": this.termsId,
      "parkId": this.parkId,
     "contentJson": {
			"overview": this.overviewtext,
			"inclexcl": {
				"incl": this.inclusionList,
				"excl": this.exclusionList
			},
			"terms": this.termsList
		},
  
      "status": "Y",
     
    }
    this.service.httpPut('parkTerm/'+this.parkId,JSON.stringify(termsDetails)).subscribe((data:any)=>{
      console.log(data);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/terms-conditions/terms-conditions.component.ts